import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import FooterSection from "./Components/FooterSection";
import { Container } from "@mui/material";
import Apps from "./Components/Apps/Apps";
import Reviews from "./Components/Reviews/Reviews";
import Faq from "./Components/FAQ/Faq";
import Privacy from "./Components/Privacy/Privacy";
import ContactUs from "./Components/ContactUs/ContactUs";
import Home from "./Components/Home/Home";
import NavBarNew from "./Components/Navigation/NavBarNew";
import Divine from "./Components/Speaker/Divine/Divine";
import Podcast from "./Components/Speaker/Podcast/Podcast";
import SpeakerTNC from "./Components/Speaker/SpeakerTNC";
import ScrollToTop from "./Components/Navigation/ScrollToTop";
import RedirectToFaq from "./Components/Navigation/RedirectToFaq";
import RedirectToPrivacy from "./Components/Navigation/RedirectToPrivacy";
import FaqIos from "./Components/FAQ/FaqIos";
import RedirectToIosFaq from "./Components/Navigation/RedirectToIosFaq";
import RedirectToPrivacySideapps from "./Components/Navigation/RedirectToPrivacySideapps";
import PrivacySideapps from "./Components/Privacy/PrivacySideapps";
import Appstrip from "./Components/AppDownloadStrip/Appstrip";


const App = () => {
  const isMobile = window.innerWidth <= 960;

  const getWebData = () => {
    return (
      <div>
        <Appstrip />
        <NavBarNew />
        <Switch>
          <Route path="/apps" component={Apps} />
          <Route path="/reviews" component={Reviews} />
          <Route path="/faq.html" component={RedirectToFaq} />
          <Route path="/ios-faq.html" component={RedirectToIosFaq} />
          <Route path="/faq" component={Faq} />
          <Route path="/ios-faq" component={FaqIos} />

          <Route exact path="/privacypolicy.html" component={RedirectToPrivacy} />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/privacypolicy/sideapps.html" component={RedirectToPrivacySideapps} />
          <Route exact path="/privacy/sideapps" component={PrivacySideapps} />

         

          <Route path="/contactus" component={ContactUs} />
          {isMobile ? "" : <Route path="/divine" component={Divine} />}
          {isMobile ? "" : <Route path="/podcast" component={Podcast} />}
          {isMobile ? "" : <Route path="/speakertnc" component={SpeakerTNC} />}
          <Route path="/" component={Home} />
        </Switch>

        <FooterSection />
      </div>
    );
  };

  return (
    <>
      <div className="App-header" style={{ backgroundColor: "#fefefe" }}>
        <Container maxWidth="xl" style={{ padding: 0 }}>
          <Router>
            <ScrollToTop />
            <Switch>
              <Route exact path="/privacy/sideapps/:viewfor" component={PrivacySideapps} />
              <Route exact path="/privacy/:viewfor" component={Privacy} />
              
              <Route path="/faq/:viewfor" component={Faq} />
              <Route path="/ios-faq/:viewfor" component={FaqIos} />
              <Route component={getWebData} />
              
            </Switch>
          </Router>
        </Container>
      </div>
    </>
  );
};

export default App;
